import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { getMiscellaneousGarnishmentEnabled } from 'selectors/session';

import GarnishmentDeduction from './GarnishmentDeduction';
import MiscDeduction from './MiscDeduction';

const PostTaxDeduction = ({ deduction, onClickEdit, showFormWithSteps }) => {
  const miscellaneousGarnishmentEnabled = useSelector(
    getMiscellaneousGarnishmentEnabled
  );

  const isMiscDeduction =
    deduction.get('type') === 'miscellaneous' ||
    (deduction.get('type') === 'miscellaneous_garnishment' &&
      miscellaneousGarnishmentEnabled);

  return isMiscDeduction ? (
    <MiscDeduction
      deduction={deduction}
      onClickEdit={onClickEdit}
      showFormWithSteps={showFormWithSteps}
    />
  ) : (
    <GarnishmentDeduction
      deduction={deduction}
      onClickEdit={onClickEdit}
      showFormWithSteps={showFormWithSteps}
    />
  );
};

PostTaxDeduction.propTypes = {
  deduction: PropTypes.object.isRequired,
  onClickEdit: PropTypes.func,
};

export default PostTaxDeduction;
